import { IPessoasOrganizacoes } from '../../../types/tables/IPessoasOrganizacoes';
import { BaseMultiTenantService } from '../base/BaseMultiTenantService';

/**
 * Serviço para gerenciamento de relacionamentos pessoa-organização com isolamento multi-tenant
 * Relacionamento N:N entre pessoas e organizações
 */
export class PessoasOrganizacoesService extends BaseMultiTenantService<IPessoasOrganizacoes> {
     constructor() {
          super(
               'pessoas_organizacoes', 
               [],
               'fk_id_organizacao'
          );
     }

     /**
      * Busca relacionamentos por pessoa
      */
     async getByPessoa(organizationId: number, pessoaId: number) {
          return await this.client
               .from('pessoas_organizacoes')
               .select(`
                    *,
                    pessoas!fk_id_pessoa (nome, email),
                    organizacoes!fk_id_organizacao (nome),
                    tipo_pessoa!fk_id_tipo_pessoa (nome, descricao)
               `)
               .eq(this.organizationIdField, organizationId)
               .eq('fk_id_pessoa', pessoaId)
               .is('deleted_at', null);
     }

     /**
      * Busca relacionamentos ativos
      */
     async getAtivos(organizationId: number) {
          return await this.client
               .from('pessoas_organizacoes')
               .select(`
                    *,
                    pessoas!fk_id_pessoa (nome, email),
                    organizacoes!fk_id_organizacao (nome),
                    tipo_pessoa!fk_id_tipo_pessoa (nome, descricao)
               `)
               .eq(this.organizationIdField, organizationId)
               .eq('ativo', true)
               .is('deleted_at', null)
               .order('data_inicio', { ascending: false });
     }

     /**
      * Busca por tipo de pessoa
      */
     async getByTipoPessoa(organizationId: number, tipoPessoaId: number) {
          return await this.client
               .from('pessoas_organizacoes')
               .select(`
                    *,
                    pessoas!fk_id_pessoa (nome, email),
                    organizacoes!fk_id_organizacao (nome),
                    tipo_pessoa!fk_id_tipo_pessoa (nome, descricao)
               `)
               .eq(this.organizationIdField, organizationId)
               .eq('fk_id_tipo_pessoa', tipoPessoaId)
               .eq('ativo', true)
               .is('deleted_at', null);
     }

     /**
      * Busca relacionamentos por período
      */
     async getByPeriodo(organizationId: number, dataInicio: string, dataFim?: string) {
          let query = this.client
               .from('pessoas_organizacoes')
               .select(`
                    *,
                    pessoas!fk_id_pessoa (nome, email),
                    organizacoes!fk_id_organizacao (nome),
                    tipo_pessoa!fk_id_tipo_pessoa (nome, descricao)
               `)
               .eq(this.organizationIdField, organizationId)
               .gte('data_inicio', dataInicio)
               .is('deleted_at', null);

          if (dataFim) {
               query = query.lte('data_inicio', dataFim);
          }

          return await query.order('data_inicio', { ascending: false });
     }

     /**
      * Desativa relacionamento (soft delete)
      */
     async desativar(organizationId: number, id: number, userId: number) {
          return await this.client
               .from('pessoas_organizacoes')
               .update({
                    ativo: false,
                    data_fim: new Date().toISOString(),
                    updated_at: new Date().toISOString(),
                    updated_by: userId
               })
               .eq(this.organizationIdField, organizationId)
               .eq('id', id)
               .select();
     }
}
